import type { RouteObject } from 'react-router-dom'

import type { NavItem } from '@/app/registry'

import { ExercisePage } from './ExercisePage'
import { ExercisesPage } from './ExercisesPage'

export const routes: RouteObject[] = [
  { path: '/exercises', element: <ExercisesPage /> },
  { path: '/exercises/:id', element: <ExercisePage /> },
]

export const nav: NavItem[] = [{ path: '/exercises', label: 'Упражнения', icon: 'dumbbell', mobile: 'more', order: 44 }]
